import { QueryFunctionContext } from '@tanstack/query-core'

import { buildApiUrl } from '@/api/core/url'
import post from '@/api/core/http/post'

import {
  leaderboardGetResponseSchema,
  LeaderboardGetResponse,
  LeaderboardGetInput
} from './schema'

export const path = `/arcade/rank/get`

export const getArcadeLeaderboard = async (
  input: LeaderboardGetInput,
  queryContext?: QueryFunctionContext
): Promise<LeaderboardGetResponse> => {
  const response = await post<LeaderboardGetResponse>(
    buildApiUrl(path, input),
    queryContext,
    leaderboardGetResponseSchema
  )
  return { ...response, timestamp: new Date().toISOString() }
}

export const allArcadeLeaderboardsQueryKey = [path] as const

export const arcadeLeaderboardQueryKey = ({
  seasonId = 'current',
  cursor = 1
}: {
  seasonId?: string
  cursor?: number
}) => [path, 'season', seasonId, 'cursor', cursor] as const
